var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('x-popup', _vm._g(_vm._b({
        ref: "popup",
        style: {
            height: '65%'
        },
        attrs: {
            "title": _vm.title,
            "position": "bottom",
            "closeable": "",
            "close-icon-position": "top-right",
            "close-on-click-overlay": false,
            "round": "",
            "get-container": "body",
            "value": _vm.value
        }
    }, 'x-popup', _vm.$attrs, false), _vm.$listeners), [
        _c('div', {
            staticClass: "inner"
        }, [
            _c('div', {
                staticClass: "content"
            }, [
                _c('ul', _vm._l(_vm.columns, function(item, index) {
                    return _c('li', {
                        key: index,
                        class: {
                            active: _vm.selection === item.mainLock
                        },
                        on: {
                            "click": function($event) {
                                return _setup.handleClick(item, index);
                            }
                        }
                    }, [
                        _vm._v(" " + _vm._s(item.worthValue) + " "),
                        _vm.selection === item.mainLock ? _c('img', {
                            attrs: {
                                "src": require("@/assets/img/icon/active-selection.png"),
                                "alt": ""
                            }
                        }) : _vm._e()
                    ]);
                }), 0)
            ])
        ])
    ]);
};
var staticRenderFns = [];
export { render, staticRenderFns };
